import { inject, observer } from 'mobx-react';
import React from 'react';
import MainSectionLayout from '../layout/MainSectionLayout';
import { Instance } from 'mobx-state-tree';
import { ActionCode, Page, TLCode } from '../../common/enums';
import { ApplicationStore, AuthenticationStore, PharmacyStore, TransferRequestStore } from '../../store';
import { RouteComponentProps } from 'react-router-dom';
import styled from '@emotion/styled';
import { css } from 'emotion';
import { Card, Tab, Tabs } from '@blueprintjs/core';
import SimpleFusionTab from './SimpleFusionTab';
import SimpleTransferTab from './SimpleTransferTab';
import TransferWithFusionTab from './TransferWithFusionTab';
import RefDataTab from './RefDataTab';
import RequestTab from './RequestTab';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { SystemStatusStore } from '../../store/SystemStatusStore';
import { SystemStatusSubSystem } from '../../common/enums/SystemStatusSubSystem';
import { SystemStatus } from '../../store/models/SystemStatus';
import ProtectionTab from './ProtectionTab';

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

const CardStyle = css({
  height: '100%',
  '& .bp3-tabs': {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  '& .bp3-tab-panel': {
    flex: 1,
  },
});

interface TransferPageProps extends RouteComponentProps<{ pharmacyId: string }>, WithTranslateProps {
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  ApplicationStore?: Instance<typeof ApplicationStore>;
  PharmacyStore?: Instance<typeof PharmacyStore>;
  SystemStatusStore?: Instance<typeof SystemStatusStore>;
  TransferRequestStore?: Instance<typeof TransferRequestStore>;
}

interface TransferPageState {
  isLoading: boolean;
  pharmacyUser: boolean;
  pharmacyId?: number;
  systemStatus?: Array<Instance<typeof SystemStatus>>;
}

@inject('AuthenticationStore')
@inject('ApplicationStore')
@inject('PharmacyStore')
@inject('SystemStatusStore')
@inject('TransferRequestStore')
@observer
class TransferPage extends React.Component<TransferPageProps, TransferPageState> {
  state = {
    isLoading: false,
    pharmacyUser: false,
  } as TransferPageState;

  _isMounted = false;

  async componentDidMount() {
    this._isMounted = true;
    this._isMounted && this.setState({ isLoading: true });
    const { PharmacyStore, AuthenticationStore, ApplicationStore, translate } = this.props;
    PharmacyStore!.loadAll();
    const userRoles = AuthenticationStore!.userActionCodes;
    await this.props.TransferRequestStore!.loadList();

    const criteria: any = {
      subSystem: 'lastPublishedDuty',
    };
    const systemStatus = await this.props.SystemStatusStore!.search(criteria);
    // @ts-ignore
    this._isMounted && this.setState({ systemStatus });

    if (userRoles.includes(ActionCode.PHARMACY_USER_CODE)) {
      if (AuthenticationStore!.pharmacyId === null) {
        ApplicationStore!.navigate(`${Page.Error}/${translate(TLCode.ERROR_NoPharmacyRelatedToThisUser)}`);
      }
      this._isMounted && this.setState({ pharmacyUser: true });

      const criteriaBP: any = {
        pharmacyId: AuthenticationStore!.pharmacyId,
        subSystem: SystemStatusSubSystem.EXCHANGE,
      };
      const systemStatus = await this.props.SystemStatusStore!.search(criteriaBP);
      // @ts-ignore
      this._isMounted && this.setState({ systemStatus });
    }

    this._isMounted && this.setState({ isLoading: false });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { PharmacyStore, translate } = this.props;
    const { isAdmin, isSuperAdmin } = this.props.AuthenticationStore!;

    const onSave = () => {};

    const pharmacyList = PharmacyStore!.dataList;
    return (
      <MainSectionLayout isLoading={this.state.isLoading}>
        <Container>
          <Card className={CardStyle.toString()}>
            <Tabs id="main" defaultSelectedTabId="simpleTransfer" renderActiveTabPanelOnly={true}>
              <Tab
                id="simpleTransfer"
                title={translate(TLCode.TRANSFER_SimpleTransferTabTitle)}
                panel={<SimpleTransferTab pharmacyList={pharmacyList} getPharmacyById={PharmacyStore!.getById} />}
                key="simpleTransferTab"
              />
              <Tab
                id="transferWithFusion"
                title={translate(TLCode.TRANSFER_TransferWithFusionTabTitle)}
                panel={
                  <TransferWithFusionTab
                    pharmacyList={pharmacyList}
                    getPharmacyById={PharmacyStore!.getById}
                    onSave={onSave}
                  />
                }
                key={'transferWithFusionTab'}
              />
              <Tab
                id="simpleFusion"
                title={translate(TLCode.TRANSFER_SimpleFusionTabTitle)}
                panel={<SimpleFusionTab pharmacyList={pharmacyList} onSave={onSave} />}
                key={'simpleFusionTab'}
              />
              {isAdmin || isSuperAdmin ? (
                <Tab
                  id="refData"
                  title={translate(TLCode.TRANSFER_RefDataTabTitle)}
                  panel={<RefDataTab />}
                  key={'refData'}
                />
              ) : (
                <></>
              )}
              <Tab
                id="requests"
                title={translate(TLCode.TRANSFER_RequestTabTitle)}
                panel={<RequestTab />}
                key={'requets'}
              />
              {/* {isSuperAdmin || isAdmin ? (
              <Tab
                id="protections"
                title={translate(TLCode.TRANSFER_ProtectionTabTitle)}
                panel={<ProtectionTab />}
                key={'protections'}
              />) : (
                <></>
              )} */}
            </Tabs>
          </Card>
        </Container>
      </MainSectionLayout>
    );
  }
}

export default withTranslate(TransferPage);
